import dynamic from "next/dynamic";
import React from "react";
import { StyleSheet, View } from "react-native-web";
import { Colors } from "../../../config";
import { getClass } from "../../../helpers/formatHelpers";

const LocationBar = dynamic(() => import("./components/LocationBar"), {
  ssr: false,
});
const MapContainer = dynamic(() => import("./components/MapContainer"), {
  ssr: false,
});

const MapView = (props) => {
  const {
    category,
    address,
    street,
    postcode,
    location,
    accomodationUrl,
    transportUrl,
    mapLink,
    venue,
    city,
    country,
    isMobileVersion,
  } = props;
  return (
    <View style={[styles.container, props.style]}>
      <View
        style={[
          styles.mapContainer,
          isMobileVersion ? { height: "auto" } : {},
        ]}>
        <MapContainer
          location={location}
          address={address}
          street={street}
          venue={venue}
          city={city}
          mapLink={mapLink}
          country={country}
          accomodationUrl={accomodationUrl}
          transportUrl={transportUrl}
          style={{ flex: 1 }}
          isMobileVersion={isMobileVersion}
        />
      </View>
      <LocationBar
        category={category}
        address={address}
        postcode={postcode}
        street={street}
        venue={venue}
        city={city}
        country={country}
        isMobileVersion={isMobileVersion}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: getClass("bg-gray1"),
    borderRadius: 20,
  },
  mapContainer: {
    height: 600,
    alignSelf: "stretch",
    borderRadius: 20,
  },
});

export default MapView;
